import { ActionIcon, Tooltip } from '@mantine/core';
import { variants } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

import 'app/modules/wallforming/custom-styles/customButtonStyle.css';

const screenWidth = window.screen.width;

export const InsertPointsVisibiltyButton = () => {
    const { t } = useTranslation();

    const { showInsertPointSelection, setShowInsertPointSelection } = usePlacementStore(
        useShallow((state) => ({
            showInsertPointSelection: state.showInsertPointSelection,
            setShowInsertPointSelection: state.setShowInsertPointSelection
        }))
    );

    const handleInsertPointsVisibility = () => {
        setShowInsertPointSelection(!showInsertPointSelection);
    };

    return (
        <Tooltip
            label={showInsertPointSelection ? t('buttonHideInsertPointSelection') : t('buttonShowInsertPointSelection')}
            position="right"
            variant={variants.tooltip.right}
        >
            <ActionIcon
                className={`
                    ${!showInsertPointSelection && 'bg-background-gray-ultra-light hover:bg-background-gray!'} catalogue-preview-action-icon
                    ${screenWidth >= 1920 ? 'action-icon-large' : 'action-icon-medium'}
                `}
                variant={showInsertPointSelection ? variants.actionIcon.activated : undefined}
                onClick={handleInsertPointsVisibility}
            >
                lasso_select
            </ActionIcon>
        </Tooltip>
    );
};
